import { useTranslation } from "react-i18next";

export const EmptyMessages = () => {
  const { t } = useTranslation("messages");

  return (
    <div className="flex-1 flex items-center justify-center p-8">
      <div className="text-center text-muted-foreground">
        <p className="text-sm">{t("No messages yet")}</p>
        <p className="text-xs mt-1">{t("Start the conversation!")}</p>
      </div>
    </div>
  );
};
